import { createApp } from 'vue';
import { createPinia } from 'pinia';

import VueLazyload from 'vue-lazyload'; // https://www.npmjs.com/package/vue-lazyload
import FloatingVue from 'floating-vue'; // https://floating-vue.starpad.dev/
import VueFinalModal from 'vue-final-modal'; // https://vue-final-modal.org/
import Vue3TouchEvents from 'vue3-touch-events'; // https://github.com/robinrodricks/vue3-touch-events
import Vue3MobileDetection from 'vue3-mobile-detection';

import router from './router';
import App from './App.vue';

const pinia = createPinia();

const app = createApp(App);

app.use(router);
app.use(pinia);

app.use(VueFinalModal);
app.use(Vue3TouchEvents, {
  swipeTolerance: 15,
});
app.use(Vue3MobileDetection);
app.use(VueLazyload, {
  preLoad: 1.3,
  observer: true,
  attempt: 1,
});
app.use(FloatingVue, {
  distance: 20,
  themes: {
    tooltip: {
      triggers: ['click', 'hover'],
      autoHide: true,
    },
    'static-tooltip': {
      $extend: 'tooltip',
      // Other options (see the 'Global options' section)'
    },
  },
});

app.mount('#app');
